/*

jv.LoadingButton
================

Easily add a loading indicator to an action button for usability++;


Usage
-----

```
<button jv-loading-button="scopeToggle">
	My Button
</button>
```

*/
angular.module('jv.Common.Directives.LoadingButton', [])

.directive('jvLoadingButton', ['$compile', function($compile){

	var spinnerClass = 'jv-loading-button-spinner';

	return {
		compile: function(tElm, tAttrs) {
			var loadingIcon = $('<div class="'+ spinnerClass +'"></div>');
			tElm.append(loadingIcon);

			return function($scope, iElm, iAttrs) {
				$scope.$watch(iAttrs.jvLoadingButton, function(loading) {
					if (loading) {
						iElm.addClass('is-loading');
					}
					else {
						iElm.removeClass('is-loading');
					}
				});
				iElm.addClass('jv-loading-button');
			};
		}
	};
}]);